import React, { useEffect, useState } from "react";
import ViewSchedule from "./ViewSchedule";
import ScheduleLayout from "./ScheduleLayout";
import { Spinner } from "react-bootstrap";
import axios from "axios";
import { useAppContext } from "../../../contexts/AppContext";
import SelectGroupUser from "./SelectGroupUser";
import RescheduleSession from "./RescheduleSession";
import { pdf } from "@react-pdf/renderer";
import SchedulePDFMyDocument from "./SchedulePDFMyDocument";
import ReScheduleConfirmModal from "./ReScheduleConfirmModal";
import UnEnrollConfirmModal from "./UnEnrollConfirmModal";

const CommonSchedulePage = () => {
  const { currentUser } = useAppContext();
  const [currentStep, setCurrentStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [rescheduleLoading, setRescheduleLoading] = useState(false);
  const [scheduleData, setScheduleData] = useState([]);
  const [rescheduleData, setRescheduleData] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [cities, setCity] = useState([]);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [selectedReschedule, setSelectedReschedule] = useState(null);
  const [isSelectedReschedule, setIsSelectedReschedule] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const totalSteps = 3;
  const [printActionTriggered, setPrintActionTriggred] = useState(false);
  const [previousSession, setPreviousSession] = useState("")
 const [isReschedule, setIsReschedule] = useState(false);
 const [isUnEnroll, setIsUnEnroll] = useState(false);
  const [isUnEnrollClicked, setIsUnEnrollClicked] = useState(false);
  useEffect(() => {
    if (currentUser?.user_id) {
      if (currentUser?.isPowerUser) {
        setCurrentStep(1);
      } else {
        setCurrentStep(2);
        getScheduleData(currentUser.user_id);
      }
    }
  }, [currentUser]);

  useEffect(()=>{
    if(currentStep === 1){
      setScheduleData([])
    } 
  }, [currentStep])

  const viewSchedule = async (groupUsers) => {
    setSelectedUser(groupUsers);
    setCurrentStep(2);
    getScheduleData(groupUsers?.value);
  };

  const getAllCity = async () => {
    const response = await axios.post(
        `${process.env.REACT_APP_API_DOMAIN}/location/regionalcity${window.location.search}`,
      {
        currentPage: 0,
        pageSize: 0,
        }, { withCredentials: true }
    );
    const _city = response.data.items;

    const options = _city.map((cty) => ({
      label: cty.name,
      value: cty.name,
    }));

    setCityOptions(options);

    setCity(_city);
  };

  const handlePrintData = async (data) => {
   
    if(printActionTriggered){
      try {
        // const response = await axios.get('/api/transcript'); // Replace with your actual API
        setLoading(true);
        var transcriptData = data.sort((a, b) => new Date(a.rawDate) - new Date(b.rawDate));;
  
        // console.log(transcriptData);
        var userName1 = "";
        var firstName1 = "";
        var lastName1 = "";
  
        if (currentUser.isPowerUser) {
          //const filteredUsers = defaultListOptions.filter(user =>
          // user.username.toLowerCase() === userNames.toLowerCase());
  
          userName1 = selectedUser.username;
          firstName1 = selectedUser.firstname;
          lastName1 = selectedUser.lastname;
        } else {
          userName1 = currentUser.username;
          firstName1 = currentUser.first_name;
          lastName1 = currentUser.last_name;
        }
        // userName1="100091589807";
        // firstName1="YAKOV";
        // lastName1="YEZHEVSKY";
  
        //  var dob= transcriptData.length > 0 ? transcriptData[0].dob : "-";
        //  userName1=transcriptData.length > 0 ? transcriptData[0].personid : userName1;
        //  firstName1=transcriptData.length > 0 ? transcriptData[0].firstname : firstName1;
        //  lastName1=transcriptData.length > 0 ? transcriptData[0].lastname : lastName1;
        const blob = await pdf(
          <SchedulePDFMyDocument
            data={transcriptData}
            firstName={firstName1}
            lastName={lastName1}
            userName={userName1}
            dob={""}
          />,
        ).toBlob();
        const url = URL.createObjectURL(blob);
        setLoading(false);
        window.open(url, "_blank");
        //    const link = document.createElement('a');
        // link.href = url;
        // link.download = "Transcript_Akhilesh.pdf";
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
        setPrintActionTriggred(false)
      } catch (error) {
        setPrintActionTriggred(false)
        setLoading(false);
        console.error("Failed to fetch transcript data", error);
      }
    }
  };

  const renderChild = () => {
    switch (currentStep) {
      case 1:
        return currentUser?.isPowerUser ? (
          <SelectGroupUser handleViewClick={viewSchedule} />
        ) : (
          <ViewSchedule
            rescheduleLoading={rescheduleLoading}
            scheduleData={scheduleData}
            rescheduleChange={rescheduleChange}
            unEnrollChange={unenrollChange}
            selectedUser={selectedUser}
            printActionTriggered={printActionTriggered}
            onPrintData={handlePrintData}
            isUnEnrollClicked={isUnEnrollClicked}
          />
        );
      case 2:
        return (
          <ViewSchedule
            rescheduleLoading={rescheduleLoading}
            scheduleData={scheduleData}
            rescheduleChange={rescheduleChange}
            unEnrollChange={unenrollChange}
            selectedUser={selectedUser}
            onPrintData={handlePrintData}
            printActionTriggered={printActionTriggered}
            isUnEnrollClicked={isUnEnrollClicked}
           
          />
        );
      case 3:
        return (
          <RescheduleSession
            rescheduleData={rescheduleData}
            cities={cities}
            handleSelectedSessionToParent={handleSelectedSessionToParent}
          />
        );
      default:
        return null;
    }
  };

  const stepContent = {
    1: {
      heading: "View or Download",
      subheading: "Click the button below to View or Download",
    },
    2: {
      heading: "In-Person and Webinar",
      subheading: "All times shown are in Pacific Standard Time.",
    },
    3: {
      heading: "Reschedule a session",
      subheading: previousSession,
    },
  };

  const onPrev = () => {
    setCurrentStep((prev) => Math.max(prev - 1, 1));
  };

  const rescheduleChange = async (selectedScedule) => {
    setPreviousSession(selectedScedule.previousSession)
    setSelectedSchedule(selectedScedule);
    await getAllCity();
    setRescheduleLoading(true);
    var resultObj = {};
    try {
      const rescheduleResponse = await axios.post(
          `${process.env.REACT_APP_API_DOMAIN}/course/reschedulesessionlst${window.location.search}`,
        {
          courseid: selectedScedule.courseId,
        },
        { withCredentials: true },
      );
      setRescheduleData(rescheduleResponse.data.rows);
      setCurrentStep(3);
      setRescheduleLoading(false);
    } catch (error) {
      resultObj.error = error;
      console.error(error);
      setRescheduleLoading(false);
    }
  };

  const handleActionChange = async () => {
    if (selectedReschedule && selectedSchedule) {
        if (currentStep != 2) {
            setIsReschedule(true);
        }
     // onRescheduleChanges(selectedReschedule);
    }
    if (currentStep === 2) {
      setPrintActionTriggred(true);
    }
  };

  const handleSelectedSessionToParent = (
    selectedSchedule,
    isScheduleSelected,
  ) => {
    setSelectedReschedule(selectedSchedule);
    setIsSelectedReschedule(isScheduleSelected);
  };

  const onRescheduleChanges = async (selectedScheduleFromChild) => {
    setRescheduleLoading(true);
    let resultObj = {};

    try {
      await getAllCity();
      const unEnrollResponse = await axios.post(
          `${process.env.REACT_APP_API_DOMAIN}/enrollment/unenroll_user_course_session${window.location.search}`,
        {
          courseId: selectedSchedule.courseId,
          userId: currentUser?.isPowerUser
            ? selectedUser.value
            : currentUser.user_id,
          sessionId: selectedSchedule.sessionId,
        },
        { withCredentials: true },
      );

      if (unEnrollResponse.data.data.success) {
        try {
          await axios.post(
              `${process.env.REACT_APP_API_DOMAIN}/enrollment${window.location.search}`,
            {
              // userIds: [currentUser.user_id],
              userIds: currentUser?.isPowerUser
                ? [selectedUser.value]
                : [currentUser.user_id],
              groupIds: [],
              branchIds: [],
              sessions: [
                {
                  sessionId: selectedScheduleFromChild.id.toString(),
                  courseId: selectedSchedule.courseId,
                },
              ],
            },
            { withCredentials: true },
          );
          getScheduleData(selectedUser?.value);
          setCurrentStep(2);
        } catch (error) {
          resultObj.error = error;
          console.error("Enrollment Error:", error);
        }
      }
    } catch (error) {
      resultObj.error = error;
      console.error("Unenrollment Error:", error);
    } finally {
      setRescheduleLoading(false);
    }

    return resultObj;
  };

  const unenrollChange = async (selectedSchedule) => {
    setSelectedSchedule(selectedSchedule);
    setIsUnEnrollClicked(true);
    setIsUnEnroll(true);
  };
const unenrollConfirm = async () => {
    // setSelectedSchedule(selectedSchedule);
    await getAllCity();
    setRescheduleLoading(true);
    var resultObj = {};
    try {
      const rescheduleResponse = await axios.post(
          `${process.env.REACT_APP_API_DOMAIN}/enrollment/unenroll_user_course_session${window.location.search}`,
        {
          courseId: selectedSchedule.courseId,
          userId: currentUser?.isPowerUser
            ? selectedUser.value
            : currentUser.user_id,
          sessionId: selectedSchedule.sessionId,
        },
        { withCredentials: true },
      );
      setRescheduleData(rescheduleResponse.data.rows);
      getScheduleData(selectedUser?.value);
      setIsSelectedReschedule(false);
      setRescheduleLoading(false);
        setIsUnEnrollClicked(false);
    } catch (error) {
      resultObj.error = error;
      console.error(error);
      setRescheduleLoading(false);
        setIsUnEnrollClicked(false);
    }
  };

  const getScheduleData = async (selectedUsers) => {
    setLoading(true);
    try {
      const initialResponse = await axios.post(
          `${process.env.REACT_APP_API_DOMAIN}/enrollment/enrolledsessionsandcourses${window.location.search}`,
        {
          UserId: currentUser?.isPowerUser
            ? selectedUsers
            : currentUser.user_id,
          Page: 1,
          PageSize: 5,
          }, { withCredentials: true }
      );

      let allCourses = [];

      if (!initialResponse?.data?.items) {
        if (initialResponse?.data?.totalPages > 0) {
          const pageRequests = [];

          for (
            let page = 2;
            page <= initialResponse?.data?.totalPages;
            page++
          ) {
            const loopCallApi = axios.post(
                `${process.env.REACT_APP_API_DOMAIN}/enrollment/enrolledsessionsandcourses${window.location.search}`,
              {
                UserId: currentUser?.isPowerUser
                  ? selectedUsers
                  : currentUser.user_id,
                Page: page,
                PageSize: 5,
                }, { withCredentials: true }
            );
            pageRequests.push(loopCallApi);
          }
          const results = await Promise.allSettled(pageRequests);

          results.forEach((result) => {
            if (result.value?.data?.items) {
              allCourses.push(...result.value.data.items);
            }
          });
        } else {
          return [];
        }
      } else {
        const totalPages = initialResponse.data.totalPages;
        allCourses = [...initialResponse.data.items];

        if (totalPages > 1) {
          const pageRequests = [];

          for (let page = 2; page <= totalPages; page++) {
            const loopCallApi = axios.post(
                `${process.env.REACT_APP_API_DOMAIN}/enrollment/enrolledsessionsandcourses${window.location.search}`,
              {
                UserId: currentUser?.isPowerUser
                  ? selectedUsers
                  : currentUser.user_id,
                Page: page,
                PageSize: 5,
                }, { withCredentials: true }
            );
            pageRequests.push(loopCallApi);
          }
          const results = await Promise.allSettled(pageRequests);

          results.forEach((result) => {
            if (result.value?.data?.items) {
              allCourses.push(...result.value.data.items);
            }
          });
        }
      }

      const groupedByDate = allCourses.reduce((acc, course) => {
        const date = course.date_start.split(" ")[0];
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(course);
        return acc;
      }, {});

      setScheduleData(groupedByDate);

      setLoading(false);
    } catch (error) {
      console.error("Error fetching schedule data:", error);
      return [];
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <ScheduleLayout
        step={currentStep}
        heading={stepContent[currentStep].heading}
        subheading={stepContent[currentStep].subheading}
        handleActionChange={handleActionChange}
        onPrev={onPrev}
        totalSteps={totalSteps}
        selectedReschedule={isSelectedReschedule}
        rescheduleLoading={rescheduleLoading}
        isPowerUser={currentUser?.isPowerUser}
      >
        {loading ? (
          <div className="container p-3 mt-3">
            <div className="row">
              <h6 className="text-center color-grey pt-5">
                <Spinner animation="border" />
              </h6>
            </div>
          </div>
        ) : (
          renderChild()
        )}
      </ScheduleLayout>
       <ReScheduleConfirmModal
        isOpen={isReschedule}
        onClose={() => setIsReschedule(false)}
        reScheduleMethod={()=>onRescheduleChanges(selectedReschedule)}
        
      />
 <UnEnrollConfirmModal
        isOpen={isUnEnroll}
        onClose={() => {setIsUnEnroll(false);
          setIsUnEnrollClicked(false);
        }}
        UnEnrollMethod={()=>unenrollConfirm()}
        
      />
      
    </div>
  );
};

export default CommonSchedulePage;
